import { EyeOutlined } from "@ant-design/icons";
import { ServicePartnerCollection } from "@rumble-it/common-lib/types/models/ServicePartnerCollection.interface";
import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";

export const servicePartnerCollectionColumns: TableColumnsType<ServicePartnerCollection> =
  [
    {
      title: "Naam",
      dataIndex: "name",
      key: "name",
      render: (_: any, record) => (
        <a href={`/service-partners/collections/${record.id}`}>{record.name}</a>
      ),
    },
    {
      title: "Beschrijving",
      key: "description",
      dataIndex: "description",
    },
    {
      title: "Herstellers",
      key: "total",
      render: (_: any, record) => record.servicePartners.length,
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: any, record) => (
        <Link to={`/service-partners/collections/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];
